'use client';
import { useState } from 'react';
import Link from 'next/link';
import { Header } from '../Header/Header';
import useModal from '../../hooks/useModal';
import { useVal } from '../../val/val.client';
import headerVal from '../../settings/header.val';

const MobileNav: React.FC = () => {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const { navigationItems, contactItem } = useVal(headerVal);
  useModal(showMenu);

  return (
    <>
      <div
        className={`flex gap-6 laptop:hidden items-center pointer-events-auto`}
      >
        <button
          className="pointer-events-auto cursor-pointer p-8 pr-[80px] bg-blank-black"
          onClick={() => setShowMenu(true)}
        >
          {/* Add right padding to make space for darkside toggle */}
          Meny
        </button>
      </div>
      {showMenu && (
        <div className="fixed top-0 left-0 h-full w-full overflow-auto bg-blank-yellow text-blank-black z-20 pointer-events-auto">
          <Header isFixed={false}>
            <button className="p-8" onClick={() => setShowMenu(false)}>
              Lukk
            </button>
          </Header>

          <div className="flex flex-col justify-between gap-128 mb-16 px-20">
            <div className="grid mt-24 gap-8 self-end">
              {[...navigationItems, contactItem].map((item, i) => {
                return (
                  <Link
                    key={i}
                    href={item.url}
                    onClick={() => setShowMenu(false)}
                    className={`text-3xl tracking-blank-tight no-underline text-right w-fit ml-auto`}
                  >
                    {item.title}
                  </Link>
                );
              })}
            </div>

            <BlankLineLogo />
          </div>
        </div>
      )}
    </>
  );
};

const BlankLineLogo = () => {
  return <div className="h-[10px] w-[42px] bg-blank-black" />;
};

export default MobileNav;
